import { parseDefiniteQuotationDTO, QuotationDTO } from 'components/ordering/quotation/api/dtos/quotation-dto.js'
import { StatusCodeToError } from 'components/ordering/quotation/api/dtos/error.js'
import {
  formatGroupAcceptedLineIds,
  LineIds
} from 'components/ordering/quotation/api/payloads/group-accepted-line-ids.js'
import { QuotationRequest } from 'components/ordering/quotation/api/quotation-request.js'


const EXPECTED_ERRORS = [400, 404] as const
type ExpectedErrors = StatusCodeToError<typeof EXPECTED_ERRORS[number]>

type ReopenQuotationPayload = {
  quotationId: number
  groupAcceptedLineIds?: LineIds
}


export class ReopenQuotation extends QuotationRequest<QuotationDTO, ExpectedErrors> {
  path: string
  override init: RequestInit
  override expectedErrors = EXPECTED_ERRORS

  constructor({ quotationId, groupAcceptedLineIds }: ReopenQuotationPayload) {
    super()

    this.path = `quotation/${quotationId}/reopen/`
    this.init = {
      method: 'POST',
      body: JSON.stringify({
        group_accepted: formatGroupAcceptedLineIds(groupAcceptedLineIds)
      }),
    }
  }

  override parseResponse = parseDefiniteQuotationDTO
}
